import dayjs from 'dayjs';
import 'dayjs/locale/id';

const INDONESIAN_MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
];

export const MONTH_OPTIONS = INDONESIAN_MONTHS.map((label, index) => ({
  label,
  value: String(index + 1).padStart(2, '0'),
}));

export const YEAR_LOOKBACK = 4;

const HISTORY_DATE_TIME_PATTERN = new RegExp(
  `\\b(\\d{1,2})\\s+(${INDONESIAN_MONTHS.join('|')})\\s+(\\d{4})\\b`,
  'i'
);

export function buildYearOptions(currentYear = dayjs().year()) {
  return Array.from({ length: YEAR_LOOKBACK + 1 }, (_, index) => {
    const year = String(currentYear - index);

    return {
      label: year,
      value: year,
    };
  });
}

export function clampMonthToCurrentYear(month, year, currentDate = dayjs()) {
  const currentYear = currentDate.format('YYYY');
  const currentMonth = currentDate.format('MM');

  if (year === currentYear && month > currentMonth) {
    return currentMonth;
  }

  return month;
}

export function formatMonthFilterDisplayLabel(month, year, currentDate = dayjs()) {
  const monthLabel = MONTH_OPTIONS.find((option) => option.value === month)?.label || '';
  const isCurrentMonth =
    year === currentDate.format('YYYY') && month === currentDate.format('MM');

  return isCurrentMonth ? `${monthLabel} (Bulan Ini)` : monthLabel;
}

export function formatYearMonthLabel(yearMonth) {
  if (!yearMonth) {
    return dayjs().locale('id').format('MMMM YYYY');
  }

  return dayjs(`${yearMonth}-01`).locale('id').format('MMMM YYYY');
}

export function formatYearMonthName(yearMonth) {
  if (!yearMonth) {
    return dayjs().locale('id').format('MMMM');
  }

  return dayjs(`${yearMonth}-01`).locale('id').format('MMMM');
}

export function getRestrictionMonthInfo(searchResult = {}) {
  const yearMonth =
    searchResult?.yearMonth ||
    searchResult?.restrictionYearMonth ||
    searchResult?.effectiveYearMonth ||
    dayjs().format('YYYY-MM');

  const currentYearMonth = dayjs().format('YYYY-MM');

  return {
    isCurrentMonth: yearMonth === currentYearMonth,
    monthLabel: formatYearMonthLabel(yearMonth),
    monthName: formatYearMonthName(yearMonth),
    yearMonth,
  };
}

export function parseHistoryDateTime(dateTime) {
  if (!dateTime) {
    const now = dayjs().locale('id');

    return {
      isCurrentMonth: true,
      monthLabel: now.format('MMMM YYYY'),
      monthName: now.format('MMMM'),
      yearMonth: now.format('YYYY-MM'),
    };
  }

  const monthMatch = dateTime.match(HISTORY_DATE_TIME_PATTERN);

  if (monthMatch) {
    const monthName = monthMatch[2];
    const monthIndex = INDONESIAN_MONTHS.findIndex(
      (item) => item.toLowerCase() === monthName.toLowerCase()
    );
    const year = monthMatch[3];
    const monthNumber = String(monthIndex + 1).padStart(2, '0');
    const yearMonth = `${year}-${monthNumber}`;
    const normalizedMonthName =
      monthIndex >= 0 ? INDONESIAN_MONTHS[monthIndex] : monthName;

    return {
      isCurrentMonth: yearMonth === dayjs().format('YYYY-MM'),
      monthLabel: `${normalizedMonthName} ${year}`,
      monthName: normalizedMonthName,
      yearMonth,
    };
  }

  const parsedDate = dayjs(dateTime);

  if (parsedDate.isValid()) {
    const localizedDate = parsedDate.locale('id');

    return {
      isCurrentMonth: localizedDate.format('YYYY-MM') === dayjs().format('YYYY-MM'),
      monthLabel: localizedDate.format('MMMM YYYY'),
      monthName: localizedDate.format('MMMM'),
      yearMonth: localizedDate.format('YYYY-MM'),
    };
  }

  const now = dayjs().locale('id');

  return {
    isCurrentMonth: true,
    monthLabel: now.format('MMMM YYYY'),
    monthName: now.format('MMMM'),
    yearMonth: now.format('YYYY-MM'),
  };
}
